<div id="login">
    <div class="loginbody">
        <div style="margin-bottom:5px;">
            <input  type="text" [(ngModel)]="username"  name="username" class="form-control" placeholder="username" />
        </div>
        <div style="margin-bottom:5px;">
            <input type="password" [(ngModel)]="password" class="form-control" placeholder="password"/>
        </div>
            <button (click)="login()" class="btn btn-primary" style="width:100%" name='login'>login</button>
    </div>
<br>
    <div class="alert alert-danger spacer-top" style="text-align:center" [ngStyle]="errorStyles" role="alert">
        {{ errorMessage }}
    </div>
</div>
<div id="footer" class="text-center">Monitoring Manager version {{version}}</div>